import React, { Component } from 'react';
import API from '../../services/API';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Icon from '../../components/Icon';
import OffersTable from './components/OffersTable';
import Form from './components/Form';
import PercentageForm from './components/PercentageForm';
import CountriesForm from './components/CountriesForm';

class Dating extends Component {
    constructor() {
        super();

        this.state = {
            offers: [],
            countries: [],
            percentage: null,
            isLoading: false,
            isShowForm: false,
            selectedOffer: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handlePercentageFormSubmit = this.handlePercentageFormSubmit.bind(this);
        this.handleCountriesFormSubmit = this.handleCountriesFormSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleDuplicate = this.handleDuplicate.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleSync = this.handleSync.bind(this);
    }

    componentDidMount() {
        this.loadOffers();
        this.loadCountries();
        this.loadPercentage();
    }

    loadOffers() {
        this.setState({ isLoading: true });

        API.Dating.Offers.get()
            .then(({ offers }) => this.setState({ offers,  isLoading: false }));
    }

    loadCountries() {
        this.setState({ isLoading: true });

        API.Dating.Countries.get()
            .then(({ countries }) => this.setState({ countries,  isLoading: false }));
    }

    loadPercentage() {
        this.setState({ isLoading: true });

        API.Dating.Percentage.get()
            .then(({ percentage }) => {
                console.log(percentage);
                this.setState({ percentage,  isLoading: false })
            });
    }


    getForm() {
        if(this.state.isShowForm) {
            return (
                <Form
                    onFormHide={this.handleFormHide}
                    onSubmit={this.handleFormSubmit}
                    offer={this.state.selectedOffer}
                />
            );
        }
    }

    handleAddBtnClick() {
        this.setState({
            isShowForm: true,
            selectedOffer: null,
            action: 'save'
        });
    }

    handleUpdate(offerID) {
        const offer = this.state.offers.find(item => item.id === offerID);
        this.setState({
            isShowForm: true,
            selectedOffer: offer,
            action: 'update'
        });
    }

    handleDuplicate(offerID) {
        const offer = this.state.offers.find(item => item.id === offerID);
        this.setState({
            isShowForm: true,
            selectedOffer: offer,
            action: 'save'
        });
    }

    handleRemove(offerID) {
        this.setState({
            isLoading: true
        });

        API.Dating.Offers.remove(offerID).then(() => {
            let { offers } = this.state;
            offers = offers.filter(item => !(item.id === offerID));


            this.setState({
                isLoading: false,
                offers
            });
        });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['bidder'], 'dating', 8081)
            .then(() => this.setState({ isLoading: false }));
    }

    handleFormHide() {
        this.setState({
            isShowForm: false
        });
    }

    handleFormSubmit({ id, ...offer }) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        if(this.state.action === 'update') {
            API.Dating.Offers.update(id, offer).then(() => this.loadOffers());
        }
        else {
            API.Dating.Offers.save(offer).then(() => this.loadOffers());
        }
    }

    handlePercentageFormSubmit(percentage) {
        this.setState({ isLoading: true });

        API.Dating.Percentage.save(percentage)
            .then(() => this.loadPercentage())
    }

    handleCountriesFormSubmit(countries) {
        this.setState({ isLoading: true });

        API.Dating.Countries.save(countries)
            .then(() => this.loadCountries())
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Dating"/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15 m-r-15" bsStyle="info" onClick={this.handleSync}> Sync</Button>
                    </Col>
                </Row>
                <PercentageForm percentage={this.state.percentage} onSubmit={this.handlePercentageFormSubmit}/>
                <CountriesForm countries={this.state.countries} onSubmit={this.handleCountriesFormSubmit}/>
                <Row>
                    <Col lg={12}>
                        <Button className="pull-right m-b-15" bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                    </Col>
                </Row>
                {this.getForm()}
                <OffersTable
                    offers={this.state.offers}
                    onUpdate={this.handleUpdate}
                    onDuplicate={this.handleDuplicate}
                    onRemove={this.handleRemove}
                />
            </Container>
        );
    }
}

export default Dating;


// WEBPACK FOOTER //
// ./src/scenes/Dating/index.js